/**
 * @file automatically generated from MApp.Endpoints.LocalizationController
 */ 

import { MetadataClient } from '../metadataClient';
import { IAvailableLocalization } from '../models';

export class LocalizationClient extends MetadataClient {

    public static getAppLauncherLocalization(language: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/applauncher/localization?language=${encodeURIComponent(language)}`),
			true
        );
    }

    public static getDesktopClientLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/desktopclient/localization`)
        );
    }

    public static getFeatureAnalyzerLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/featureanalyzer/localization`)
        );
    }

    public static getRiaClientLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v4/riaclient/localization`)
        );
    }

    public static getStudioLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization`)
        );
    }

    public static getDefaultLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/detect`),
			true
        );
    }

    public static getLocalizations() {
        return MetadataClient.ajax<IAvailableLocalization[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/localizations`),
			true
        );
    }

    public static getAllLocalizations() {
        return MetadataClient.ajax<IAvailableLocalization[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/localizations/all`)
        );
    }

    public static getCldrLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/cldr`)
        );
    }

    public static getDefaultCldrLocalization() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/cldr/detect`),
			true
        );
    }

    public static getAvailableLocalizations() {
        return MetadataClient.ajax<IAvailableLocalization[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/localization/available`)
        );
    }
}
